<script lang="ts">
  import { FormGroup } from "carbon-components-svelte";
  import ImageEditor from "../common/ImageEditor.svelte";
  import type APIClient from "src/ts/APIClient";
  import type { IImage } from "src/ts/Interfaces";

  export let client: APIClient;
  export let canvasWidth: number;
  export let canvasHeight: number;
  export let images: IImage[] = [];
  export let hidden: boolean;
</script>

{#if !hidden}
  <div class="pane">
    <FormGroup legendText="Upload a logo" class="step">
      <ImageEditor {canvasWidth} {canvasHeight} bind:images {client} />
    </FormGroup>
  </div>
{/if}
